module.exports = __webpack_public_path__ + "img/moniterstu1.25d38dce.jpeg";